import './utils/network'

import { AppId, Language } from '@shared/types'
import { CommonBankApp } from '@ui-common/components/CommonBankApp'
import { Translations } from '@ui-common/types'

import { DigilaAnalyticsContext, useDigilaAnalyticsContextValue } from './analytics/analytics'
import { Wizard } from './components/Wizard'
import messagesFi from './l10n/fi.json'
import messagesSv from './l10n/sv.json'

const messages: Translations = {
  [Language.Fi]: { ...messagesFi },
  [Language.Sv]: { ...messagesSv },
}

const App = () => {
  const analyticsContextValue = useDigilaAnalyticsContextValue()

  return (
    <CommonBankApp appId={AppId.DigiLa} translations={messages}>
      <DigilaAnalyticsContext value={analyticsContextValue}>
        <Wizard />
      </DigilaAnalyticsContext>
    </CommonBankApp>
  )
}

export default App
